export const ANSWERS__GET = 'ANSWERS__GET';
export const ANSWERS__PATCH = 'ANSWERS__PATCH';
export const ANSWERS__POST = 'ANSWERS__POST';
